import { render, staticRenderFns } from "./ask-info2.vue?vue&type=template&id=5461ac16"
import script from "./ask-info2.vue?vue&type=script&lang=ts"
export * from "./ask-info2.vue?vue&type=script&lang=ts"
import style0 from "./ask-info2.vue?vue&type=style&index=0&id=5461ac16&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5461ac16')) {
      api.createRecord('5461ac16', component.options)
    } else {
      api.reload('5461ac16', component.options)
    }
    module.hot.accept("./ask-info2.vue?vue&type=template&id=5461ac16", function () {
      api.rerender('5461ac16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/ask-info2.vue"
export default component.exports